import type { ContactsTierSelectData, ContactsTierSelectHandlers } from '@ctct/application-layer';
import { ContactsTierSelect } from '@ctct/payflow-ui';
import type { ContactsTierSelectHooks } from '@ctct/state-client-layer';

interface Props {
  data: ContactsTierSelectData;
  handlers: ContactsTierSelectHandlers;
  hooks: ContactsTierSelectHooks;
  isSingleBillChildAccount?: boolean;
}

export const ContactsTierSelectWidgetContent = ({ data, handlers, hooks, isSingleBillChildAccount }: Props) => {
  const contactTier = hooks.useContactsTier();
  const disabled = Boolean(hooks.useDisabled() || isSingleBillChildAccount);
  const tiers = data.getTiersOptions();
  const labels = data.getLabels();

  return (
    <ContactsTierSelect
      contactTiersOptions={tiers}
      selectedContactTier={contactTier}
      onContactsTierSelect={handlers.onContactsTierChange}
      contactTiersLabel={labels.contactTiersLabel}
      disabled={disabled}
    />
  );
};
